/**
 * PCOR Routes
 * legacy app: Not in head-routing (likely added later)
 * Defaulting to: canActivate: [AuthGuard, VendorRoleGuard]
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const PCOR = lazy(() => import('@src/apps/PCOR/Pcor').then(m => ({ default: m.Pcor })));

export const pcorRoutes: RouteConfig[] = [
  {
    path: 'pcor/*',
    component: PCOR,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Patient Care Opportunity Reporting',
      breadcrumb: 'PCOR',
      preload: false,
      delay: true,
    },
  },
];

